module.exports = __webpack_public_path__ + "static/media/santosh_chaudhary_review.d8ddca66.webm";